export default "__VITE_ASSET__41ec5593__"